import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectToHubSessiones } from "src/redux/slices/hub";
import { receiveDataFromHub, setUserSuccess } from "src/redux/slices/authJwt";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";

export default function useHubSessions() {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.authJwt);

  const isConnectedRef = useRef(false); // Para evitar reconexiones innecesarias

  // Funciones optimizadas con useCallback para evitar recreaciones innecesarias
  const handleSessionUpdate = useCallback(
    (s) => {
      dispatch(receiveDataFromHub(s));
    },
    [dispatch]
  );

  const handleUserUpdate = useCallback(
    (user) => {
      dispatch(setUserSuccess(user));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!session || isConnectedRef.current) return;

    isConnectedRef.current = true; // Marcar como conectado para evitar duplicados

    const cleanup = CreateConnection(
      // El hub de session usa grupo session-{id} específicamente: los broadcasts
      // session/{id} del backend van a ese grupo para no notificar a otras sesiones.
      buildHubUrl("/hub/sessionhub", {
        sessionId: session.id,
        restauranteId: session.idRestaurante,
      }),
      [
        {
          id: `session/${session.id}`,
          operator: handleSessionUpdate,
        },
        {
          id: `session/updateUser/${session.id}`,
          operator: handleUserUpdate,
        },
      ],
      dispatch,
      connectToHubSessiones,
      "session"
    );

    return () => {
      cleanup(); // Asegura que se limpie la conexión al desmontar o cambiar `session`
      isConnectedRef.current = false; // Permite futuras reconexiones si es necesario
    };
  }, [session, dispatch, handleSessionUpdate, handleUserUpdate]);
}
